import type { RateInputs, RateOutputs } from '../types/rates';
import { rateApiClient } from '../api/rateApiClient';

// Lookup rates using the API
export async function lookupRates(inputs: RateInputs): Promise<RateOutputs> {
  // Validate Investment Date
  if (!inputs.investmentDate) {
    throw new Error('Ensure a valid Investment Date is selected');
  }

  // Call the API
  const response = await rateApiClient.lookupRates(inputs);

  // Debug logging
  if ((import.meta as { env?: Record<string, string> }).env?.VITE_DEBUG_LOGGING === 'true') {
    console.log('==== INPUT DATA ====');
    console.log(inputs);
    
    console.log('==== OUTPUT DATA ====');
    console.log(response);
  }

  return response;
}